module.exports = __webpack_public_path__ + "static/img/545.9695bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/545.png
// module id = 1215
// module chunks = 33